<template>
  <div>
    <div class="position-relative">
      <label for="search-input" class="search-icon">
        <font-awesome-icon :icon="['far', 'search']" />
      </label>
      <input
        id="search-input"
        type="text"
        class="form-control search-text pl-4"
        :placeholder="$t(this.placeholder)"
        :value="value"
        @input="inputCaptured"
        ref="searchInput"
      />
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import Vue from 'vue';

export default Vue.extend({
  name: 'HMSearch',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'GENERAL.PLACEHOLDER.SEARCH',
    },
    delay: {
      type: Number,
      default: 400,
    },
  },
  computed: {
    inputCaptured() {
      return debounce(this.onInput, this.delay);
    },
  },
  methods: {
    onInput($event) {
      this.$emit('input', $event.target.value);
    },
  },
  mounted() {
    const input = this.$refs.searchInput;
    this.$emit('initialized', input);
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.search-icon {
  position: absolute;
  display: flex;
  align-items: center;
  height: 100%;
  color: var(--brand-color, $coral);
  margin-left: 0.5rem;
}
.search-text {
  &::placeholder {
    font-style: normal;
  }
}
</style>
